export default {
  DRAFT: 'draft',
  SENT: 'sent',
  DUE: 'due',
  PAID: 'paid',
  REMOVED: 'removed'
}
